exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".documents-component-box[data-v-73591f5a]{padding:20px}.test-form[data-v-73591f5a]{width:50%}", ""]);

// exports
